import { createFileRoute } from '@tanstack/react-router'

import { Authorisation } from '@/lib/auth/components/auth-provider'
import Unauthorized from '@/lib/auth/components/unauthorized'
import { PERMISSIONS, ROLES } from '@/lib/auth/roles'
import DateFilter from '@/lib/filters/date/date-filter'
import { isCurrentPage, validateSearchWithDefaults } from '@/lib/utils'
import FreeTextAnalysis from '@/modules/free-text-analysis'
import { freeTextAnalysisQueryOptions } from '@/modules/free-text-analysis/hooks'
import { defaultFetchParamsFreeTextAnalysis, FreeTextAnalysisSearch, mergedFreeTextAnalysisSearchSchema } from '@/types/route-search-schemas'
import { DataLoader } from '@/types/router-context'
import { FREE_TEXT_ANALYSIS_PATH, FREE_TEXT_ANALYSIS_URL } from '@/utils/urls'

export const Route = createFileRoute(FREE_TEXT_ANALYSIS_PATH)({
  component: FreeTextAnalysisPage,
  validateSearch: (search: Record<string, unknown>): FreeTextAnalysisSearch => validateSearchWithDefaults(mergedFreeTextAnalysisSearchSchema, search),
  loader: ({ context: { queryClient, date, permissions } }: DataLoader) => {
    // Skip the prefetch when AI controls disable the feature, as the endpoint would only return a 403
    if (isCurrentPage(FREE_TEXT_ANALYSIS_URL) || !permissions.includes(PERMISSIONS.CAN_VIEW_SENSITIVE_ANSWERS)) {
      return
    }
    queryClient.prefetchQuery(freeTextAnalysisQueryOptions(date, defaultFetchParamsFreeTextAnalysis))
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [
        { label: 'Client actions', path: '#' },
        { label: 'Sensitive answers', path: '/' }
      ],
      children: <DateFilter />
    }
  }
})

function FreeTextAnalysisPage() {
  return (
    <div className="flex flex-col items-center justify-center p-8 sm:p-0">
      <Authorisation roles={[ROLES.ROLE_ELEVATION]} permissions={[PERMISSIONS.IS_FIRM_WIEW_OR_IS_NETWORK_VIEW_ON_NETWORK, PERMISSIONS.CAN_VIEW_SENSITIVE_ANSWERS]} forbiddenFallback={<Unauthorized />}>
        <FreeTextAnalysis />
      </Authorisation>
    </div>
  )
}
